export default __webpack_public_path__ + "static/1-6ea68316073dd876c57ec6f7f3dba9c0.jpeg";